<template>
  <v-app>
    <v-main id="forgot" :class="{ 'white-bg': $vuetify.breakpoint.smAndDown }">
      <v-container fluid>
        <v-row justify="center" class="mt-9">
          <Logo />
        </v-row>
        <v-row justify="center">
          <v-col cols="12" xs="12" md="4" style="max-width: 400px;">
            <v-card class="card px-2 py-0 elevation-0">
              <v-card-text class="pa-7" :class="{ 'pt-1': $vuetify.breakpoint.smAndDown }">
                <SignError :error="error" />

                <div
                  class="card-title pb-5"
                  :class="{
                    'white--text': $vuetify.theme.dark,
                    'darkTextGrey--text': !$vuetify.theme.dark,
                  }"
                >
                  <p>{{ $t(`views.forgot.title`) }}</p>
                </div>
                <div class="card-subtitle pb-5">
                  <p>{{ $t(`views.forgot.subtitle`) }}</p>
                </div>

                <v-form @submit.prevent="submit">
                  <v-text-field
                    v-model="email"
                    :label="$t('views.login.email.label')"
                    name="email"
                    type="text"
                    :placeholder="$t('views.login.email.placeholder')"
                    :disabled="loading"
                  />
                  <div>
                    <v-btn
                      type="submit"
                      color="primary"
                      :loading="loading"
                      :disabled="submitDisabled"
                      class="submit-button elevation-0 mt-2"
                    >
                      <span>{{ $t('views.forgot.continue') }}</span>
                    </v-btn>
                  </div>
                </v-form>
                <div class="links mt-7">
                  <v-divider class="pt-4"></v-divider>
                  <a @click="!loading && $router.replace({ name: 'login' })">
                    {{ $t('views.forgot.goLogin') }}
                  </a>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-0">
          <LanguageSelector />
        </v-row>
        <v-row justify="center" class="my-5 mr-2">
          <ThemeSelector />
        </v-row>
      </v-container>

      <dashboard-core-footer />
    </v-main>
  </v-app>
</template>

<script>
import SignMixin from '@/views/components/sign/signMixin.js'
import SignError from '@/views/components/sign/SignError'
import firebase from 'firebase/app'
import { mapState } from 'vuex'

export default {
  components: { SignError },
  mixins: [SignMixin],
  data: () => ({
    email: null,
  }),
  computed: {
    ...mapState(['language']),
    submitDisabled() {
      return !this.email
    },
  },
  methods: {
    async submit() {
      return this.forgot()
    },
    async forgot() {
      try {
        this.loading = true
        firebase.auth().languageCode = this.language
        await firebase.auth().sendPasswordResetEmail(this.email)
        this.setSignMessage({ signMessage: 'forgotSent' })
        this.$router.replace({
          name: 'login',
        })
      } catch (error) {
        this.error = error.code
        this.loading = false
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
.white-bg {
  background-color: white !important;
}
.theme--dark {
  .white-bg {
    background-color: #1e1e1e !important;
  }
}
#forgot {
  // background: #f9fafc;
  .card {
    text-align: center;
    .card-error {
      font-size: 14px;
      font-weight: 300;
    }
    .card-title {
      font-size: 20px;
      font-weight: 300;
    }
    .card-subtitle {
      font-size: 15px;
      font-weight: 300;
    }
    .submit-button {
      width: 100%;
    }
    .links {
      font-size: 14px;
      font-weight: 300;
    }
  }
}
.theme--dark {
  #forgot {
    hr {
      border-color: #a5a5a5;
    }
  }
}
</style>
